import { ApiTagTypes, innovorderApi } from '../index';
import { ApiRequest, ApiResponse } from '../request.types';
import {
    FiscalityProviderResponse,
    GetFiscalityProviderPayload,
    GetRestaurantVatRatesParams,
    RestaurantVatRatesResponse,
    UpsertFiscalityProviderPayload,
} from './fiscalityProvider.type';

const fiscalityProviderApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getFiscalityProvider: build.query<FiscalityProviderResponse, ApiRequest<GetFiscalityProviderPayload>>({
            query: ({ restaurantId, operationZoneId, token }) => ({
                url: `/api/v1/restaurants/${restaurantId}/fiscality-provider`,
                method: 'GET',
                params: { operationZoneId },
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            transformResponse: (response: ApiResponse<FiscalityProviderResponse>) => response.data,
            providesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 3 },
        }),
        upsertFiscalityProvider: build.mutation<void, ApiRequest<UpsertFiscalityProviderPayload>>({
            query: ({ restaurantId, token, ...body }) => ({
                url: `/api/v1/restaurants/${restaurantId}/fiscality-provider`,
                method: 'POST',
                body,
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            invalidatesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 0 },
        }),
        getRestaurantVatRates: build.query<RestaurantVatRatesResponse, GetRestaurantVatRatesParams>({
            query: ({ restaurantId }) => ({
                url: `/api/v1/restaurants/${restaurantId}/vat-rates`,
                method: 'GET',
            }),
            transformResponse: (response: ApiResponse<RestaurantVatRatesResponse>) => response.data,
        }),
    }),
});

export const { useGetFiscalityProviderQuery, useUpsertFiscalityProviderMutation, useGetRestaurantVatRatesQuery } =
    fiscalityProviderApi;
